/**
 * HTTP API contract between client and server (everything else goes through
 * the Yjs doc). Paths are relative to the site origin.
 */

/** Upload: `POST /api/blobs` multipart/form-data with a single `file` field. */
export const BLOBS_UPLOAD_PATH = "/api/blobs";
/** Download: `GET /api/blobs/:key` streams the blob with its stored content-type. */
export const blobPath = (key: string) => `/api/blobs/${encodeURIComponent(key)}`;
/** Same-origin authored assets or immutable copies belonging to a publication. */
export function isLocalBlobUrl(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const match = /^\/api\/(?:publications\/[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/)?blobs\/([a-zA-Z0-9_%.-]+)$/i.exec(value);
  if (!match) return false;
  try { const key = decodeURIComponent(match[1]!); return key !== "." && key !== ".." && !/[\/\\?#%]/.test(key); } catch { return false; }
}


export interface BlobUploadResponse {
  key: string;
  /** Same as blobPath(key). Store this in ObjectFields.blobUrl or ChatMessage.attachments. */
  url: string;
  mime: string;
  sizeBytes: number;
  fileName: string;
}

/** Max upload size accepted by the server (bytes). */
export const MAX_BLOB_BYTES = 100 * 1024 * 1024;

/** Server health: `GET /healthz` -> { ok: true, ... } */
export const HEALTHZ_PATH = "/healthz";

/** Websocket sync endpoint (y-websocket protocol; room name = DOC_NAME). */
export const SYNC_PATH = "/sync";

/**
 * GET → DefaultSkillsResponse: the skills shipped with Aquaduck (read from `agents/skills/<name>/SKILL.md`
 * at boot). The server seeds them into every workspace's `skills` map (id `skill_default_<name>`) when absent.
 */
export const DEFAULT_SKILLS_PATH = "/api/skills/defaults";

/** `GET /api/agent/models` → AgentModelsResponse: the model ids this deployment lets a workspace choose for its agent. */
export const AGENT_MODELS_PATH = "/api/agent/models";
export interface AgentModelOption { id: string; label: string; /** True for the server default (`OPENAI_MODEL`). */ default?: boolean }
export interface AgentModelsResponse { models: AgentModelOption[] }
export interface DefaultSkill { name: string; title: string; markdown: string; description?: string }
export interface DefaultSkillsResponse { skills: DefaultSkill[] }
